<template>
  <div>
    <MultipleAreaBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :tables="pageData"
      :isFooter="isFooter"
    >
      <template v-slot:[pageData[0].name]>
        <ClientInfo
          :recItems="recItems"
          :pageType="isHistoryType ? 'history' : 'register'"
        />
      </template>
      <template v-slot:[pageData[1].name]>
        <OperationDetail
          :recItems="recItems"
          :type="pageType.en"
          :isEdit="isEdit"
          :isTotalAmount="isTotalAmount"
        >
          <template #button v-if="isHistoryType">
            <slot :name="pageData[1].buttonAreaName" />
          </template>
        </OperationDetail>
        <!-- <ProductTable
          :headers="recDetail.productListHeaders"
          :items="recItems.productMoves"
          item-key="product.productNumber"
          productKey="productMoveId"
        >
        </ProductTable>
        <slot :name="pageData[1].name" v-bind:item="item" />
        <NormalButton
          text="発注修正"
          height="32px"
          color="white"
          textColor="thinText--text"
          class="pa-2 mx-1"
          btnClass="px-3"
          :outlined="true"
          @click="edit(pageData)"
          v-if="isHistoryType"
        /> -->
      </template>

      <template v-if="!isEdit" v-slot:[pageData[2].name]>
        <v-row class="mx-3 my-2">
          <v-col>
            <Remarks
              title="order.order_company-note-phrase"
              text="sale.sale_not-listed-on-the-invoice"
              v-model="remarks.private"
              :isRegister="isHistoryType"
              @updateRemarks="updateRemarksPrivate"
            />
          </v-col>
          <v-col>
            <Remarks
              title="order.order_purchase-order-remarks-column"
              text="order.order_public-info-on-the-order-supplier-info"
              v-model="remarks.client"
              :isRegister="isHistoryType"
              @updateRemarks="updateRemarksClient"
            />
          </v-col>
        </v-row>
      </template>

      <!-- 詳細のみ -->
      <template v-if="isHistoryType" v-slot:[pageData[3].name]>
        <!-- 入庫履歴 -->
        <slot :name="pageData[3].name" />
      </template>
      <template
        v-if="isHistoryType && (authority.isAdmin || authority.isUser)"
        v-slot:[pageData[4].name]="{ item }"
      >
        <!-- 出金履歴 -->
        <slot :name="pageData[4].name" v-bind:item="item" />
      </template>
      <template
        v-if="isHistoryType"
        v-slot:[pageData[getChangeHistoryIndex].name]
      >
        <!-- 修正履歴 -->
        <slot :name="pageData[getChangeHistoryIndex].name" />
      </template>

      <template #footer>
        <slot name="footer" />
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
// import { mapActions } from 'vuex'

import MultipleAreaBase from '../MultipleAreaBase'

import headersHistory from '@/views/order/History/headers'
import ClientInfo from '@/components/layouts/ClientConfirmation/SpplierInfo/SpplierInfoBase'
import OperationDetail from '@/components/layouts/OperationDetail/OperationDetail'
import { ProductTable, Remarks } from '@/components/items'

// import headersLoading from '@/views/order/Loading/headers'

// import NormalButton from '@/components/items/Buttons/NormalButton'

export default {
  components: {
    MultipleAreaBase,
    ClientInfo,
    OperationDetail,
    // ProductTable,
    Remarks
    // NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    },

    pageData: {
      type: Array,
      require: true,
      default: () => []
    },

    isHistoryType: { default: false },
    isFooter: { default: false },
    isEdit: { default: false },
    isTotalAmount: { default: true }
  },
  data: () => ({
    pageType: {
      en: 'order',
      ja: '発注'
    },

    recDetail: {
      productListHeaders: headersHistory.productListHeaders
    },

    remarks: {
      private: '',
      client: ''
    }
    // loading: {
    //   historyListInfo: {
    //     historyList: [],
    //     headers: headersLoading.headers,
    //     tableKey: headersLoading.tableKey,
    //     productListHeaders: headersLoading.productListHeaders
    //   }
    // }
  }),

  methods: {
    updateRemarksPrivate(...args) {
      const [remarks] = args
      this.$emit('updateRemarks', remarks, 'private')
    },
    updateRemarksClient(...args) {
      const [remarks] = args
      this.$emit('updateRemarks', remarks, 'client')
    },
    setDefaultRemarks() {
      if (!this.recItems.orderNote || this.recItems.orderNote.length == 0) {
        this.remarks = {
          private: '',
          client: ''
        }
        return
      }
      const privateRemarks = this.recItems.orderNote.find(
        (ele) => ele.type == 1
      )
      if (privateRemarks) this.remarks.private = privateRemarks.body
      const clientRemarks = this.recItems.orderNote.find((ele) => ele.type == 2)
      if (clientRemarks) this.remarks.client = clientRemarks.body
    }
    // ...mapActions('Loading', ['getLoadingListFromApi']),
    // register() {
    //   this.$emit('register')
    // },
    // cancel(id) {
    //   this.$emit('cancel', id)
    // },
    // edit(rec) {
    //   this.$emit('edit')
    // }
    // async ini() {
    //   const loadingList = await this.getLoadingListFromApi({
    //     orderControlNumber: this.recItems.transaction.controlNumber
    //   })
    //   const format = loadingList.data.map((ele, Index) => {
    //     ele.panelIndex = Index + 1
    //     return ele
    //   })
    //   this.loading.historyListInfo.historyList = format
    // }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    getChangeHistoryIndex() {
      return this.authority.isAdmin || this.authority.isUser ? 5 : 4
    }
  },
  watch: {
    remarks: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('editRemarks', newVal)
      }
    },
    recItems: {
      handler(newVal, oldVal) {
        this.setDefaultRemarks()
      },
      deep: true,
      immediate: true
    },
    'inputedValue.dialog': async function (val) {
      // val ? await this.ini() : null
    }
  }
}
</script>
<style lang="scss" scoped>
// .productTableCom {
//   ::v-deep .v-data-table th {
//     background-color: rgba(151, 198, 234, 0.1);
//     padding-left: 30px;
//   }
//   ::v-deep .v-data-table td {
//     padding-left: 30px;
//   }
// }
.normalNumberInput {
  width: 180px;
}
.stepComponent {
  width: 150px;
}
.btnStyle {
  width: 90px;
}
</style>
